import React from 'react';


function MustachePrice(props) {

    return (

        <React.Fragment>
            {/* <!-- Item starts --> */}
            <div class="menu-item my-4">
                <div class="row border-dot no-gutters">
                    <div class="col-8 menu-item-name">
                        <h6>{props.text}</h6>
                    </div>
                    <div class="col-4 menu-item-price text-right">
                        <h6>{props.price}</h6>
                    </div>
                </div>
            </div>
            {/* <!-- Item ends --> */}
        </React.Fragment>
    )
}

export default MustachePrice;

